function infiniteLoopAnimation() {
    let outerContainers = document.querySelectorAll('.infinite-loop-container');

    outerContainers.forEach(container => {
        if (container.classList.contains('md:hidden') && window.innerWidth > 768) {
            return;
        }

        const divToClone = container.querySelector('.infinite-loop-logos');

        if (!divToClone) {
            return;
        }

        /* Get number of logos */
        const logoCount = divToClone.querySelectorAll('.infinite-loop-logo').length;

        //  Adding a copy of the <span> to see the actual width because
        //  browser adds a space after the <span> text if followed by another <span>
        container.appendChild(divToClone.cloneNode(true));

        //  Find how many times the span can fit on the screen and round it up
        const cloneTimes = Math.ceil(window.innerWidth / divToClone.offsetWidth);
        const repeatTimes = cloneTimes * 2;

        for (var j = 0; j < repeatTimes - 1; j++) {
            container.appendChild(divToClone.cloneNode(true));
        }

        //  Set new width of the text container
        const newWidth = divToClone.offsetWidth * repeatTimes;
        container.style.setProperty("width", newWidth + "px");

        const fromX = 0;

        //  If there are more than one lines of text, make
        //  every next row offset by one screen width
        const toX = (-1 * repeatTimes * divToClone.offsetWidth / 2) + (-1 * window.innerWidth);

        const animDuration = 5 * logoCount;

        container.style.setProperty('--animate-from-x', `${fromX}px`);
        container.style.setProperty('--animate-to-x', `${toX}px`);
        container.style.setProperty('--animation-duration', `${animDuration}s`);

        /* gsap.fromTo(textContainer, { x: fromX }, { x: toX, duration: animDuration, repeat: -1, ease: 'power0' }); */
    });
}

export { infiniteLoopAnimation };